module.exports = __webpack_public_path__ + "static/media/learning-12.7ecc0c06.png";